module.exports = __webpack_public_path__ + "img/admission-6.9c6b7117.jpg";